<template>
  <div v-loading="tableLoading">
    <div>
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        style="margin:10px;"
        >全部选择</el-checkbox
      >
      <span
        style="margin-left:20px;font-size:14px;cursor: pointer;"
        @click="buyAndDownloads()"
        >批量下载</span
      >
      <span
        style="margin-left:20px;font-size:14px;cursor: pointer;"
        @click="delAllCarts()"
        >批量删除</span
      >
    </div>
    <div class="demo-image">
      <el-checkbox-group
        v-model="checkedCities"
        @change="handleCheckedCitiesChange"
      >
        <el-checkbox
          v-for="fit in this.obj.datalists"
          :label="fit.fccUuid"
          :key="fit.fccUuid"
          class="my-checkbox"
        >
          <div class="block">
            <div class="icons">
              <el-tooltip effect="dark" content="预览" placement="top">
                <span
                  ><i class="el-icon-search" @click="handleImgPreview(fit)"></i
                ></span>
              </el-tooltip>
              <el-tooltip effect="dark" content="下载" placement="top">
                <span
                  ><i class="el-icon-download" @click="buyAndDownload(fit)"></i
                ></span>
              </el-tooltip>

              <el-tooltip effect="dark" content="删除" placement="top">
                <span
                  ><i
                    class="el-icon-delete"
                    @click="delOneCarts(fit.fccUuid)"
                  ></i
                ></span>
              </el-tooltip>
            </div>
            <div class="content" v-loading="fit.status != 0">
              <el-image
                style="width:100%; height: 100%;display: inline-block;vertical-align: middle;"
                :src="fit.describe"
                fit="contain"
              >
                <div
                  slot="error"
                  class="image-slot"
                  style="width:100%; height: 100%;display: inline-block;vertical-align: middle;"
                >
                  <img
                    :src="fit.icon"
                    style="object-fit:contain;width:100%; height: 100%;"
                    alt
                  />
                </div>
              </el-image>
              <div class="toolbar"></div>
            </div>
            <div class="image-detail" v-if="!fit.isDown">
              尺寸:{{ typeFormat(fit) }}
            </div>
            <div class="image-detail2" v-else>
              <a rel="nofollow" :href="fit.downUrl" target="_blank"
                ><el-button
                  type="primary"
                  size="small"
                  style="margin-top:5px;width: 75px;text-align:center"
                  >点击下载</el-button
                ></a
              >
              <a rel="nofollow" :href="fit.downUrl1" target="_blank"
                ><el-button
                  type="success"
                  size="small"
                  style="margin-left:5px; margin-top:5px;width: 75px;text-align:center"
                  >备用下载</el-button
                ></a
              >
            </div>
          </div>
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="this.obj.total"
      v-if="this.obj.total > 50"
    ></el-pagination>

    <el-dialog
      :visible.sync="imgPreviewVisible"
      center
      :show-close="false"
      append-to-body
    >
      <template #title>
        <DialogCloseBtn @close="imgPreviewVisible = false" />
        图片预览
      </template>
      <div style="width:100%;text-align:center;max-height:450px;overflow:auto">
        <el-image :src="currentImg">
          <div slot="error" class="image-slot">
            <img
              :src="currentError"
              style="object-fit: fill; width:100%;height:107.5%"
              alt
            />
          </div>
        </el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buy_delCarts, hasBlance } from "../../../api/downLoad";
import { getSessionUser } from "../../../api/auth";
import { delCarts } from "../../../api/order";
import { message } from "@/utils/resetMessage";
import DialogCloseBtn from "@/components/DialogCloseBtn.vue";
import { downloadFile as safeDownloadFile } from "@/utils/download";
// 下载实现已统一收敛到 @/utils/download：
// 那边给 iframe 加了 sandbox，万一下载地址返回的是 HTML（CDN 缺 /topze-dispatch/ 回源规则时
// 会兜底成 SPA 的 index.html），也不会在 iframe 里把整个应用重启、污染同源 localStorage。
export const downloadFile = safeDownloadFile;
export default {
  components: {
    DialogCloseBtn,
  },
  props: {
    obj: {
      type: Object,
    },
  },
  computed: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 50,
      tableLoading: false,
      checkedCities: [],
      cityOptions: [],
      cities: [],
      checkAll: false,
      isIndeterminate: false,
      imgPreviewVisible: false,
      currentIndex: 0,
      currentError: "",
      currentImg: "",
    };
  },
  mounted() {
    this.$EventBus.$on("nextCartId", (data) => {
      //将A组件传递过来的参数data赋值给msgB
      if (data >= 0) {
        this.currentIndex = data + 1;
        //更新余额
        getSessionUser({})
          .then((result) => {
            this.$store.dispatch("setUserInfo", result);
          })
          .catch((error) => {});
        if (this.currentIndex < this.cities.length) {
          var item = this.cities[this.currentIndex];
          var itemObj = {};
          this.obj.datalists.forEach((item1) => {
            if (item1.fccUuid == item) {
              itemObj = item1;
              return;
            }
          });
          this.buyAndDownloadOne(itemObj, this.currentIndex);
        } else {
          //下载完成
          message.success({
            message: "批量下载完成",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
        }
      }
    });
  },
  beforeDestroy() {
    this.$EventBus.$off("nextCartId");
  },
  methods: {
    handleImgPreview(row) {
      this.imgPreviewVisible = true;
      this.currentImg =
        "https://img.aatuku.com/preview260/" + row.recCode + ".jpg";
      this.currentError = row.icon;
    },
    handleCheckAllChange(val) {
      if (this.obj.datalists.length > this.cityOptions.length) {
        this.obj.datalists.forEach((item1) => {
          this.cityOptions.push(item1.fccUuid);
        });
      }
      this.checkedCities = val ? this.cityOptions : [];
      this.cities = val ? this.cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      if (this.obj.datalists.length > this.cityOptions.length) {
        this.obj.datalists.forEach((item1) => {
          this.cityOptions.push(item1.fccUuid);
        });
      }
      this.cities = value;
      this.checkAll = checkedCount === this.cityOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cityOptions.length;
    },
    typeFormat(row) {
      if (row.format === "4") {
        return "EPS矢量";
      } else {
        return "JPG大图";
      }
    },
    delOneCarts(row) {
      let dataform = {
        ids: row,
      };
      delCarts(dataform)
        .then((result) => {
          message.success({
            message: "您已经成功移除。",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
          this.handleRefresh();
        })
        .catch((error) => {
          message.error({
            message: "您移除失败，请重试。",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
          this.handleRefresh();
        });
    },
    delAllCarts() {
      if (this.cities.length == 0) {
        message.error({
          message: "请先选择需要删除的图片",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        return;
      }
      var items = "";
      this.cities.forEach((item) => {
        items += item + ",";
      });
      items = items.substring(0, items.length - 1); //去除最后一个逗号
      let dataform = {
        ids: items,
      };
      delCarts(dataform)
        .then((result) => {
          message.success({
            message: "您已经成功移除。",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
          this.handleRefresh();
        })
        .catch((error) => {
          message.error({
            message: "您移除失败，请重试。",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
          this.handleRefresh();
        });
    },
    buyAndDownload(row) {
      row.status = 1;
      let dataform = {
        imageIDs: row.recCode,
        webType: "shutterstock_V3",
      };
      hasBlance(dataform)
        .then(async (result) => {
          if (result) {
            //如果余额足够，则开始获取下载链接
            let buydata = {
              fccUuid: row.fccUuid,
            };
            buy_delCarts(buydata)
              .then((res) => {
                row.status = 0;
                if (res.downloadUrl != "" && res.downloadUrl != null) {
                  //进行下载
                  row.isDown = true;
                  row.downUrl = res.downloadUrl;
                  row.downUrl1 = res.downloadUrl2;
                  message.success({
                    message: "下载成功，可以在下载记录查询",
                    showClose: true,
                    duration: 4000,
                    offset: 100,
                  });
                } else {
                  //重试一次
                  row.status = 0;
                  message.error({
                    message: "下载失败，请重新尝试或联系上方微信客服",
                    showClose: true,
                    duration: 4000,
                    offset: 100,
                  });
                }
              })
              .catch((error) => {
                //重试一次
                buy_delCarts(buydata)
                  .then((res) => {
                    row.status = 0;
                    if (res.downloadUrl != "" && res.downloadUrl != null) {
                      row.isDown = true;
                      row.downUrl = res.downloadUrl;
                      row.downUrl1 = res.downloadUrl2;
                    } else {
                      //重试一次
                      row.status = 0;
                      message.error({
                        message: "下载失败，请重新尝试或联系上方微信客服",
                        showClose: true,
                        duration: 4000,
                        offset: 100,
                      });
                    }
                  })
                  .catch((error) => {
                    row.status = 0;
                    message.error({
                      message: "下载失败，请重新尝试或联系上方微信客服",
                      showClose: true,
                      duration: 4000,
                      offset: 100,
                    });
                  });
              });
          } else {
            row.status = 0;
            message.error({
              message: "余额不足，请先充值",
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
        })
        .catch((error) => {
          row.status = 0;
          message.error({
            message: "余额不足，请先充值",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
        });
    },
    buyAndDownloadOne(row, index) {
      row.status = 1;
      let dataform = {
        imageIDs: row.recCode,
        webType: "shutterstock_V3",
      };
      hasBlance(dataform)
        .then(async (result) => {
          if (result) {
            //如果余额足够，则开始获取下载链接
            let buydata = {
              fccUuid: row.fccUuid,
            };
            buy_delCarts(buydata)
              .then((res) => {
                row.status = 0;
                if (res.downloadUrl != "" && res.downloadUrl != null) {
                  //进行下载
                  row.isDown = true;
                  row.downUrl = res.downloadUrl;
                  row.downUrl1 = res.downloadUrl2;
                  this.$EventBus.$emit("nextCartId", index); //下一个ID
                  message.success({
                    message: "下载成功，可以在下载记录查询",
                    showClose: true,
                    duration: 4000,
                    offset: 100,
                  });
                } else {
                  //重试一次
                  this.$EventBus.$emit("nextCartId", index); //下一个ID
                  message.error({
                    message: "下载失败，请重新尝试或联系上方微信客服",
                    showClose: true,
                    duration: 4000,
                    offset: 100,
                  });
                }
              })
              .catch((error) => {
                //重试一次
                buy_delCarts(buydata)
                  .then((res) => {
                    row.status = 0;
                    if (res.downloadUrl != "" && res.downloadUrl != null) {
                      row.isDown = true;
                      row.downUrl = res.downloadUrl;
                      row.downUrl1 = res.downloadUrl2;
                      this.$EventBus.$emit("nextCartId", index); //下一个ID
                    } else {
                      //重试一次
                      this.$EventBus.$emit("nextCartId", index); //下一个ID
                      message.error({
                        message: "下载失败，请重新尝试或联系上方微信客服",
                        showClose: true,
                        duration: 4000,
                        offset: 100,
                      });
                    }
                  })
                  .catch((error) => {
                    row.status = 0;
                    this.$EventBus.$emit("nextCartId", index); //下一个ID
                    message.error({
                      message: "下载失败，请重新尝试或联系上方微信客服",
                      showClose: true,
                      duration: 4000,
                      offset: 100,
                    });
                  });
              });
          } else {
            row.status = 0;
            message.error({
              message: "余额不足，请先充值",
              showClose: true,
              duration: 4000,
              offset: 100,
            });
          }
        })
        .catch((error) => {
          row.status = 0;
          message.error({
            message: "余额不足，请先充值",
            showClose: true,
            duration: 4000,
            offset: 100,
          });
        });
    },
    buyAndDownloads() {
      if (this.cities.length == 0) {
        message.error({
          message: "请先选择需要下载的图片",
          showClose: true,
          duration: 4000,
          offset: 100,
        });
        return;
      }
      this.currentIndex = 0;
      var item = this.cities[this.currentIndex];
      var itemObj = {};
      this.obj.datalists.forEach((item1) => {
        if (item1.fccUuid == item) {
          itemObj = item1;
          return;
        }
      });
      this.buyAndDownloadOne(itemObj, this.currentIndex);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.$emit("sizeChange", val);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit("pageChange", val);
    },
    handleRefresh() {
      this.$emit("refreshChange", 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-image {
  margin-top: 15px;
  .block {
    margin-bottom: 10px;
    position: relative;
    &:hover {
      .icons {
        visibility: visible;
      }
    }
    .content {
      width: 155px;
      height: 155px;
      border: 1px solid rgb(221, 221, 221);
    }
  }
}
.my-checkbox {
  margin-right: 0;
  position: relative;

  ::v-deep .el-checkbox__label {
    padding-left: 0;
  }
}

.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.my-checkbox ::v-deep .el-checkbox__input {
  position: absolute;
  right: 10px;
  top: 135px;
}
.icons {
  visibility: hidden;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  z-index: 1000;

  span {
    display: inline-block;
    text-align: center;
    width: 32px;
    height: 32px;
    line-height: 29px;
    border-radius: 30px;
    margin-left: 10px;
    background: #0773fc;
    color: white;

    i {
      font-size: 15px;
    }

    &:hover {
      background-color: rgba($color: #0773fc, $alpha: 0.8);
    }
  }
}

.image-detail {
  width: 100%;
  text-align: center;
  font-size: 15px;
  color: black !important;
  padding: 5px 0;
  font-weight: bold;
}

.image-detail2 {
  width: 100%;
  text-align: center;
  font-size: 15px;
  color: black !important;
  font-weight: bold;
}
</style>
